// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"251":"5b6b5a74","344":"f45bf193","571":"5b6b5a74"}[chunkId] + ".chunk.css";
};